import React from 'react'
import { Link } from 'react-router-dom'
import { CreateLink } from '../../utils'
import SocialMediaLinks from '../../components/SocialMediaLinks'
import { withLocale } from '../../locale/withLocale'
import { trackStartRegistration } from '../../analytics'
import useLocale from '../../hooks/useLocale'

function BlogFooter() {
  const { language } = useLocale()

  return (
    <div className="o-width-limiter o-width-limiter--mid">
      <div className="c-signup-cta">
        <p className="c-signup-cta__text">Be a healthier you!</p>
        <Link
          to={CreateLink('signup', language)}
          className="c-button c-button--primary"
          onClick={() => {
            trackStartRegistration({
              entryPoint: 'Blog',
              flowName: 'Regular',
            })
          }}
        >
          <span>Sign up for Lifesum</span>
        </Link>
      </div>
      <SocialMediaLinks />
    </div>
  )
}

export default withLocale(BlogFooter)
